import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container, Form, Row, Col, Alert, Button, Image, ListGroup } from 'react-bootstrap';
import { authActions } from '../../store/auth';
import { config } from '../../config';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
    const [haveInvitations, setHaveInvitations] = useState(false);
    const [invitationsList, setInvitationsList] = useState([]);

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email) {
            setErrorMsg('E-mail filed is required');
            return;
        }

        if (!password || password.length < 8) {
            setErrorMsg('Password not valid, Password should be at least 8 characters');
            return;
        }

        setLoginButtonDisabled(true);

        let bodyToSend = '';
        if (haveInvitations) {
            const invlist = invitationsList.map((i) => { return { _id: i._id, accepted: i.checked } });
            bodyToSend = JSON.stringify({ email, password, invitations: invlist });
        } else {
            bodyToSend = JSON.stringify({ email, password });
        }

        const response = await fetch(`${config.url}/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: bodyToSend
        });

        const resData = await response.json();

        setLoginButtonDisabled(false);

        if (!response.ok) {
            let showErrorMsg = 'Error has occurred when trying to login';
            if (resData && resData.message) {
                showErrorMsg = resData.message + ' ';
            }
            if (resData && resData.data && resData.data[0] && resData.data[0].msg) {
                showErrorMsg += resData.data[0].msg;
            }
            setErrorMsg(showErrorMsg);
            return;
        }

        setErrorMsg('');

        if (resData.status === 'not-activated') {
            navigate('/activate-mail-msg');
        }

        else if (resData.status === 'have-invitations') {
            setHaveInvitations(true);
            setInvitationsList(resData.invitations ? resData.invitations.map((i) => { return { ...i, checked: true } }) : []);
        }

        else if (resData.status === 'empty-workspaces') {
            navigate('/create-workspace/' + resData.token);
        }

        else if (resData.status === 'is-login') {
            localStorage.setItem('token', resData.token);

            const user = {
                userId: resData.userId,
                workspaceId: resData.workspaceId,
                workspaceName: resData.workspaceName,
                name: resData.name,
                firstName: resData.firstName,
                lastName: resData.lastName,
                email: resData.email,
                profileImage: resData.profileImage,
                workspaces: resData.workspaces,
            }

            localStorage.setItem('user', JSON.stringify(user));
            dispatch(authActions.login(user));

            navigate('/sys');
        }
    }

    const handleEnterKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin(e);
        }
    }

    const handleInvitationsCheckedChange = (invId, value) => {
        const updatedInvitationsList = JSON.parse(JSON.stringify(invitationsList));
        const invIndex = updatedInvitationsList.findIndex(i => i._id === invId);
        if (invIndex >= 0) {
            updatedInvitationsList[invIndex].checked = value;
            setInvitationsList(updatedInvitationsList);
        }
    }

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh' }}>
            {!haveInvitations && (
                <Container>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="4">
                            <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="4">
                            <h3 style={{ color: '#1ad7ad' }}>Login</h3>
                        </Col>
                    </Row>
                    {errorMsg &&
                        <Row className="justify-content-md-center mt-3">
                            <Col sm="12" md="4">
                                <Alert variant="danger">{errorMsg}</Alert>
                            </Col>
                        </Row>
                    }
                    <Row className="justify-content-md-center mt-3">
                        <Col sm="12" md="4">
                            <Form>
                                <Form.Group className="mb-4" controlId="formGroupEmail">
                                    <Form.Label style={{ color: '#1ad7ad' }}>Email address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" onChange={(e) => { setEmail(e.target.value) }} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formGroupPassword">
                                    <Form.Label style={{ color: '#1ad7ad' }}>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        onChange={(e) => { setPassword(e.target.value) }}
                                        onKeyDown={handleEnterKeyPress}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Link to="/reset-password" style={{ fontSize: '14px', color: '#FFFFFF' }}>Forgot Password</Link>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center mt-5">
                        <Col sm="12" md="4">
                            <Button
                                variant="gray"
                                style={{ backgroundColor: '#1ad7ad', color: '#29303d', width: '150px' }}
                                onClick={handleLogin}
                                disabled={loginButtonDisabled}>Login</Button>
                        </Col>
                    </Row>
                </Container>
            )}

            {haveInvitations && (
                <Container>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="4">
                            <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="4">
                            <h3 style={{ color: '#1ad7ad' }}>Invitations</h3>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="4">
                            <h3 style={{ color: '#1ad7ad' }}>Accept or reject your invitations</h3>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-3">
                        <Col sm="12" md="4">

                            <ListGroup as="ul">

                                {invitationsList.length > 0 && invitationsList.map(inv => {
                                    return (
                                        <ListGroup.Item
                                            key={inv._id}
                                            as="li"
                                            className="d-flex justify-content-between align-items-start p-4 mb-2"
                                        >
                                            <div className="me-auto">
                                                <div className="fw-bold">{inv.workspace.name}</div>
                                            </div>
                                            <Form.Check
                                                type="checkbox"
                                                checked={inv.checked}
                                                onChange={(e) => { handleInvitationsCheckedChange(inv._id, e.target.checked) }} />
                                        </ListGroup.Item>
                                    );
                                })}

                            </ListGroup>

                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center mt-5">
                        <Col sm="12" md="4">
                            <Button
                                variant="gray"
                                style={{ backgroundColor: '#1ad7ad', color: '#29303d', width: '150px' }}
                                onClick={handleLogin}
                                disabled={loginButtonDisabled}>Next</Button>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
}

export default Login;
